import { Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import JailerActionDirectorPost from "@/pages/blog/JailerActionDirectorChethanDsouza";
import Jailer2ActionDirectionPost from "@/pages/blog/Jailer2ActionDirection";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* Unlisted — intentionally not linked from any nav/page. Direct-URL + sitemap only. */}
      <Route path="/blog/jailer-2-action-director-chethan-dsouza" element={<JailerActionDirectorPost />} />
      <Route path="/blog/jailer-2-chethan-dsouza-action-direction" element={<Jailer2ActionDirectionPost />} />
      <Route path="/blog/jailer-2-chethan-dsouzas-action-direction" element={<Jailer2ActionDirectionPost />} />
    </Routes>
  );
}

export default App;
